module.exports = {
      id: "edit-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "svg-sprite-fef6f85605acbf641cce7cd75d6011b0.svg#edit",
      toString: function () {
        return this.url;
      }
    }